module.exports = __webpack_public_path__ + "static/img/3.82e320a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/3.png
// module id = 7gpf
// module chunks = 1